import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export interface Country {
  iso: string; // ISO 3166-1 alpha-2 code
  dialCode: string; // Dialing prefix, e.g. "+91"
  name: string;
  flag: string; // flag emoji
}

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

function getFlagEmoji(countryCode: string): string {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

// Generate the complete list dynamically from libphonenumber-js
const allCountriesList: Country[] = getCountries()
  .map((iso) => {
    let name = iso;
    try {
      name = regionNames.of(iso) || iso;
    } catch (e) {}

    let dialCode = "";
    try {
      dialCode = `+${getCountryCallingCode(iso)}`;
    } catch (e) {}

    return {
      iso,
      name,
      dialCode,
      flag: getFlagEmoji(iso),
    };
  })
  .filter((c) => c.dialCode);

// Prioritize featured countries to appear at the top
const featuredIsos = ["IN", "US", "GB", "CA", "AU", "AE", "SG", "DE", "FR", "NZ", "ZA"];

const featuredCountries = featuredIsos
  .map((iso) => allCountriesList.find((c) => c.iso === iso))
  .filter((c): c is Country => !!c);

const otherCountries = allCountriesList
  .filter((c) => !featuredIsos.includes(c.iso))
  .sort((a, b) => a.name.localeCompare(b.name));

export const countries: Country[] = [...featuredCountries, ...otherCountries];

// Helper for maximum phone digits per country
export const maxPhoneLengths: Record<string, number> = {
  IN: 10,
  US: 10,
  CA: 10,
  GB: 10,
  AU: 9,
  AE: 9,
  SG: 8,
  DE: 11,
  FR: 9,
  NZ: 9,
  ZA: 9,
};
